import { NgModule } from '@angular/core';

// IMPORTS
import { CommonModule } from '@angular/common';

// DECLARATIONS / EXPORTS
import { FiltercallbackPipe } from './filter/filtercallback.pipe';
import { CapitalizePipe } from './capitalize/capitalize.pipe';

@NgModule({
  imports: [
    CommonModule
  ]
  ,
  declarations: 
  [
    CapitalizePipe
  , FiltercallbackPipe
  ]
  ,
  exports:
  [
    CapitalizePipe
  , FiltercallbackPipe
  ]
})
export class PipesModule { }
